/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import { InputButton } from "components/UI";
//Utils
import { messageDisplay, responseErrors, responseSuccess } from "utils";
import { formatCol } from "../hooks/formatCol";
// Hook
import { useConfirmDialogContext } from "context/confirmDialogContext";
//Constant
import { MSG_TYPE } from "state/enum";
import { API_EXCEL } from "shared/constants";
import {
  useExcelDownloadConfirmRecordMutation,
  useExcelDownloadExcelFileMutation,
  useExcelDownloadCsvFileMutation,
  useExcelDownloadToOnDemandMutation,
  useGenSignedUrlMutation,
} from "shared/services/common/monitoring";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { useSelector } from "react-redux";
import { ResponseText } from "utils/5xxResponseText";
import axios from "configs/axiosConfig";
export default function ActionBar(props) {
  const {
    form,
    rows,
    rowSelection: { rowSelectionModel },
    setMsg: { setMsgAlert, setMsgError },
    functionId,
  } = props;
  const confirmDialogCtx = useConfirmDialogContext();
  const user = useSelector(state => state.auth.user);
  const { startLoading, stopLoading } = useLoadingContext();
  const confirmRecord = useExcelDownloadConfirmRecordMutation();
  const excelDownload = useExcelDownloadExcelFileMutation();
  const csvDownload = useExcelDownloadCsvFileMutation();
  const uploadToOnDemand = useExcelDownloadToOnDemandMutation();
  const genSignedUrl = useGenSignedUrlMutation();
  // constant value
  const NO_RECORD = 0;
  const BaseServicePath = process.env.REACT_APP_API_COMMON;
  const BaseServicePathSystemWarning = process.env.REACT_APP_API_SYSTEM_WARNING;
  const handleDownload = async (event, fileType) => {
    setMsgAlert([]);
    setMsgError([]);
    try {
      const edited = formatCol(rowSelectionModel, rows);
      const body = {
        [API_EXCEL.DATA_OWNER]: form?.dataOwner,
        [API_EXCEL.TABLE_NAME]: form?.tableName,
        [API_EXCEL.SETTING_ID]: form?.bookMasks,
        [API_EXCEL.REPORT_NAME]: form?.reportName,
        [API_EXCEL.REPORT_TITLE]: form?.reportTitle,
        [API_EXCEL.START_COLUMN]: form?.startColumn,
        [API_EXCEL.START_ROW]: form?.startRow,
        [API_EXCEL.BIG_DATA]: form?.bigData ? "1" : "0",
        [API_EXCEL.COLUMNS]: edited,
        [API_EXCEL.USER]: {
          [API_EXCEL.USER_INFO]: {
            [API_EXCEL.NAME]: user?.userName,
            [API_EXCEL.EMAIL]: user?.mail,
            [API_EXCEL.COMPANY_ABBR]: user?.companyAbbr,
            [API_EXCEL.COUNTRY]: user?.country,
            [API_EXCEL.BRANCH]: user?.branch,
          },
          [API_EXCEL.ROLE]: form?.roleId,
        },
      };
      startLoading();
      const confirmResult = await confirmRecord(body);

      waitAndGetCountRecord(1200, confirmResult?.result?.id, body, fileType, event);
    } catch (error) {
      stopLoading();
      const errors = responseErrors(error);
      setMsgError(errors);
      window.scrollTo(0, 0);
      return false;
    }
  };
  const waitAndGetCountRecord = (limit, id, body, fileType, event) => {
    const timer = 2;
    let count = 0;

    const state = setInterval(async () => {
      count += timer;
      try {
        if (count >= limit) {
          clearInterval(state);
          console.error("TimeOut");
          setMsgError([`${ResponseText[504]}`]);
          stopLoading();
          throw new Error("TimeOut");
        }
      } catch (error) {
        clearInterval(state);
        console.error("An error occurred while checking the download status:", error);
        setMsgError([`An error occurred while checking the download status:, ${error}`]);
        stopLoading();
        return error;
      }

      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API_URL}${BaseServicePathSystemWarning}/process-checking/${id}`,
          method: "GET",
        });
        // console.log("waitAndGetCountRecord result", response);
        const { count: record, status } = response?.data;
        if (status === "S") {
          clearInterval(state);
          // if record in table === 0 will show data not found
          if (Number(record) === NO_RECORD) {
            setMsgError([messageDisplay({ type: MSG_TYPE.ERROR, code: "MSTD0059AERR", msg: "" })]);
            stopLoading();
            return false;
          }
          // console.log(process.env.REACT_APP_MAX_RECORD_REPORT);
          if (record > process.env.REACT_APP_MAX_RECORD_REPORT && !form?.bigData) {
            setMsgError([
              messageDisplay({
                type: MSG_TYPE.ERROR,
                code: "MSTD1066AERR",
                msg: [process.env.REACT_APP_MAX_RECORD_REPORT],
              }),
            ]);
            stopLoading();
            return false;
          }
          stopLoading();
          if (form?.bigData) {
            const downloadConfirm = await confirmDialogCtx.success({
              type: "COMMON_EXCEL_DOWNLOAD",
              msg: record,
            });
            if (!downloadConfirm) {
              stopLoading();
              return false;
            }
            startLoading();
            const response = await uploadToOnDemand(body, fileType);
            stopLoading();
            const msg = responseSuccess(response);
            setMsgAlert([msg]);
            window.scrollTo(0, 0);
            return true;
          } else if (!form?.bigData && fileType === "excel") {
            await handleExcelDownloadFile(fileType, record, body, event);
          } else if (!form?.bigData && fileType === "csv") {
            await handleCsvDownloadFile(fileType, record, body, event);
          }
          return true;
        }
      } catch (error) {
        stopLoading();
        clearInterval(state);
        const msg = responseErrors(error);
        setMsgError(msg);
        // return;
      }
    }, timer * 1000);
  };
  const handleExcelDownloadFile = async (fileType, record, body, event) => {
    try {
      const downloadConfirm = await confirmDialogCtx.success({
        type: "COMMON_EXCEL_DOWNLOAD",
        msg: record,
      });
      if (!downloadConfirm) {
        return false;
      }
      startLoading();
      // Export Excel or Csv
      const result = await excelDownload(body, fileType);
      waitAndDownloadExcel(1200, result.data, event, true);
      // stopLoading();
      return true;
    } catch (error) {
      stopLoading();
      const err = responseErrors(error);
      setMsgError(err);
      window.scroll(0, 0);
      return;
    }
  };

  const handleCsvDownloadFile = async (fileType, record, body, event) => {
    try {
      const downloadConfirm = await confirmDialogCtx.success({
        type: "COMMON_EXCEL_DOWNLOAD",
        msg: record,
      });
      if (!downloadConfirm) {
        return false;
      }
      // Export Excel or Csv
      startLoading();
      const result = await csvDownload(body, fileType);
      waitAndDownloadExcel(1200, result.data, event, false);
      // stopLoading();
      return true;
    } catch (error) {
      stopLoading();
      const err = responseErrors(error);
      setMsgError(err);
      window.scroll(0, 0);
      return;
    }
  };

  const handleDownloadS3File = async (event, pathName) => {
    const targetLink = event.target.getAttribute("href");
    let expires = 0;
    try {
      if (targetLink && targetLink.startsWith("http")) {
        const url = new URL(targetLink);
        expires = (+url.searchParams.get("Expires") || 0) * 1000;
      }

      if (Date.now() > expires) {
        const result = await genSignedUrl({ key: pathName });
        window.open(result.data.url, "_blank");
      }
    } catch (error) {
      const err = reportError(error);
      setMsgError(err);
      window.scroll(0, 0);
      return;
    }
  };
  const waitAndDownloadExcel = (limit, response, e) => {
    const timer = 2;
    let count = 0;

    const { docId } = response?.result;
    const state = setInterval(async () => {
      count += timer;
      try {
        if (count >= limit) {
          clearInterval(state);
          console.error("TimeOut");
          setMsgError([`${ResponseText[504]}`]);
          stopLoading();
          throw new Error("TimeOut");
        }
      } catch (error) {
        clearInterval(state);
        console.error("An error occurred while checking the download status:", error);
        setMsgError([`An error occurred while checking the download status:, ${error}`]);
        stopLoading();
        return error;
      }

      try {
        const fileStatus = await axios({
          url: `${process.env.REACT_APP_API_URL}${BaseServicePath}/download/status?docId=${docId}`,
          method: "GET",
        });

        const { data } = fileStatus;
        if (data?.status === "3") {
          clearInterval(state);
          if (data?.pathName) {
            await handleDownloadS3File(e, data?.pathName);
            stopLoading();
            return;
          } else {
            setMsgError([`${ResponseText[500]}`]);
            stopLoading();
            return;
          }
        } else if (data?.status === "6") {
          clearInterval(state);
          setMsgError([`${ResponseText[500]}`]);
          stopLoading();
          return;
        }
      } catch (error) {
        stopLoading();
        clearInterval(state);
        const msg = responseErrors(error);
        setMsgError(msg);
        return;
      }
    }, timer * 1000);
  };

  return (
    <Fragment>
      <InputButton
        id="btn-excel-download"
        value="Excel Download"
        disabled={false}
        onClick={e => handleDownload(e, "excel")}
        name={`${functionId}ExcelDownload`}
      />
      <InputButton
        id="btn-csv-download"
        value="CSV Download"
        disabled={false}
        onClick={e => handleDownload(e, "csv")}
        name={`${functionId}CSVDownload`}
      />
    </Fragment>
  );
}
